import AbstractBlockType from "~/cabinet/vue/interface/htmlConstructor/blocks/AbstractBlockType";
import StructureDisplay from "~/cabinet/vue/interface/htmlConstructor/blocks/structure/StructureDisplay.vue";
import StructureForm from "~/cabinet/vue/interface/htmlConstructor/blocks/structure/StructureForm.vue";
import IStructureBlockValues from "~/cabinet/vue/interface/htmlConstructor/blocks/structure/IStructureBlockValues";
import {RawComponent, useRawComponent} from "~/core-ui/ts/useRawComponent";


export default class StructureBlockType extends AbstractBlockType<IStructureBlockValues, any> {


    get displayComponent(): RawComponent {
        return useRawComponent(StructureDisplay);
    }

    get formComponent(): RawComponent {
        return useRawComponent(StructureForm);
    }



    hasLeftRightPadding(value: IStructureBlockValues): boolean {
        return false;
    }

}
